/* eslint-disable no-undef */
import Cookies from "universal-cookie";
import CryptoJS from "crypto-js";
import { useDispatch } from "react-redux";
import { useRef, useEffect } from "react";
import { hideOffCanvas, hideOffCanvasLast, hideOffCanvasThree, setCommonAlert } from "../commonSlice";
import { DateTime } from 'luxon';
const cookies = new Cookies();
export const serverZone = cookies.get('serverZone') || 'UTC';

export function formatDate(dateString) {
  const [month, year] = dateString.split('/');
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const monthName = monthNames[parseInt(month, 10) - 1];
  return `${monthName} ${year}`;
}

//$ convertion 
export const formatAsDollar = (value) => {
  // Use Intl.NumberFormat for number formatting
  const formattedValue = new Intl.NumberFormat("en-SG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  return `S$${formattedValue}`;
};

export const convertEpochToISO8601 = (epochMillis) => {
  const date = new Date(epochMillis); // convert milliseconds to a Date object
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000+00:00`;
};

let isLoggingOutWithWarning = false;

export const setLoggingOutWithWarning = (value) => {
  isLoggingOutWithWarning = Boolean(value);
  try {
    if (value) {
      sessionStorage.setItem("isLoggingOutWithWarning", "true");
    } else {
      sessionStorage.removeItem("isLoggingOutWithWarning");
    }
  } catch (e) {
    // Ignore storage errors in restricted contexts
  }
};

export const isLogoutDeferred = () => {
  try {
    return isLoggingOutWithWarning || sessionStorage.getItem("isLoggingOutWithWarning") === "true";
  } catch (e) {
    return isLoggingOutWithWarning;
  }
};

export function logOut() {
  if (isLogoutDeferred()) {
    // A logout warning notification (e.g. USER_DISABLED via WebSocket) is actively
    // displaying to the user. Defer immediate redirect so the alert stays visible for 5s.
    return;
  }
  window.location.href = "/auth";
  sessionStorage.setItem("isLoggedin", false);
  sessionStorage.setItem("lastVistedURL", window.location.pathname);
  cookies.remove("username", { path: "/" });
  cookies.remove("apitoken", { path: "/" });
  cookies.remove("jwttoken", { path: "/" });
  cookies.remove("Refersh", { path: "/" });
  cookies.remove("referstoken", { path: "/" });
}

export const handleResponseCode = (response) => {
  try {
    if (response?.status === 403) {
      logOut();
    } else if (response?.redirected) {
      logOut();
    } else if (response?.status === 401) {
      logOut();
    }

    return response;
  } catch (error) {
    console.error("An error occurred while handling the response:", error);
  }
};

export const setRedirectPath = () => {
  const actualUrlBeforeDecode = window.location.href;
  const actualUrl = decodeURIComponent(actualUrlBeforeDecode).replaceAll(" ", "");
  let urlArray = actualUrl.split('#');
  if (actualUrl.includes("redirectedFromEmail")) {
    const allUrl = urlArray[1] && urlArray[1].split("&");
    let appName = allUrl ? allUrl[1] || "" : "";
    const appCode = appName.split("=")[1];
    const refId = allUrl[2] ? allUrl[2].split("=")[1] : "";
    localStorage.setItem("redirectURlAppNames", appCode);
    localStorage.setItem("redirectURL", actualUrl);
    localStorage.setItem("refIdForSelectedVulnerabilites", refId);
  }
};

function convertEpochTimeToMilliseconds(epochTime) {
  if (epochTime > 1e12) {
    return epochTime;
  } else {
    const epochTimeInMilliseconds = epochTime * 1000;
    return epochTimeInMilliseconds;
  }
}

export const convertEpochToDate = (givenDate) => {
  if (givenDate === "null" || givenDate === 0) {
    return '-';
  }

  // Convert epoch to DateTime in server's timezone
  const dateTime = DateTime.fromMillis(
    convertEpochTimeToMilliseconds(givenDate),
    { zone: serverZone }
  );

  // Format components
  const day = dateTime.toFormat('dd');
  const month = dateTime.toFormat('MM');
  const year = dateTime.toFormat('yyyy');
  const hours = dateTime.toFormat('HH');
  const minutes = dateTime.toFormat('mm');

  return `${day}/${month}/${year}, ${hours}:${minutes}`;
};

export function convertToEpoch(dateString) {
  const epochTime = Date.parse(dateString);
  return epochTime / 1000; // Convert milliseconds to seconds
}

export function formatDateYear(givenDate) {
  if (givenDate === "null") {
    return '-';
  }

  const dateObj = new Date(convertEpochTimeToMilliseconds(givenDate));

  const day = dateObj.toLocaleString('en-US', { day: '2-digit' });
  const month = dateObj.toLocaleString('en-US', { month: '2-digit' });
  const year = dateObj.toLocaleString('en-US', { year: 'numeric' });


  return `${day}/${month}/${year}`;
}

export const encrypt = (data) => {
  const SECRET = "DevopsLabs2024";
  const key = CryptoJS.enc.Utf8.parse('En' + SECRET);
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString();

  const urlSafeEncrypted = encrypted
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

  return urlSafeEncrypted;
};


export const decrypt = (encryptedData) => {
  try {
    const key = "DevopsLabs2024";
    const dataToDecrypt = encryptedData.slice(4, -3);

    const secretKeyString = "En" + key;

    const keyBytes = CryptoJS.enc.Utf8.parse(secretKeyString);

    const base64Encrypted = dataToDecrypt
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(dataToDecrypt.length + (4 - dataToDecrypt.length % 4) % 4, '=');

    const encryptedBytes = CryptoJS.enc.Base64.parse(base64Encrypted);

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedBytes },
      keyBytes,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedText;

  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

//Common Alert
export const useCommonAlert = () => {
  // this is the way to call the function
  // callCommonAlert("error","Something went wrong. Please try again.");
  // hideCommonAlert();
  //type =success,warning,error


  const dispatch = useDispatch();
  const alertTimeoutRef = useRef(null);
  const navigateClearRef = useRef(true);

  const callCommonAlert = (type, msg, clearNavigate) => {
    navigateClearRef.current = clearNavigate;
    if (alertTimeoutRef.current) {
      clearTimeout(alertTimeoutRef.current);
    }
    dispatch(setCommonAlert({
      openAlert: true,
      alertType: type,
      alertMessage: msg,
      clearNavigate, // give true when alertpopup to show when navigate(unmounts)
    }));
  };

  const hideCommonAlert = (duration) => {
  // 🔄 Clear any existing timers
  if (alertTimeoutRef.current) {
    clearTimeout(alertTimeoutRef.current);
    alertTimeoutRef.current = null;
  }

  const delay = typeof duration === "number" && duration >= 0 ? duration : 3000;


  alertTimeoutRef.current = setTimeout(() => {
   
    dispatch(setCommonAlert({
      openAlert: false,
      alertType: "",
      alertMessage: "",
    }));
    alertTimeoutRef.current = null;
  }, delay);
};

  useEffect(() => { // prevent unwanted popup alert when navigting(unmount) through pages
    return () => {
      if (alertTimeoutRef.current && navigateClearRef.current) {
        clearTimeout(alertTimeoutRef.current);
      }
      if (!navigateClearRef.current) {
        dispatch(
          setCommonAlert({
            openAlert: false,
            alertType: "",
            alertMessage: "",
          }),
        );
      }
    };
  }, []);
  return { callCommonAlert, hideCommonAlert };
};
export const encryptData = (data) => {
  const SECRET = "DevopsLabs2024";
  const key = CryptoJS.enc.Utf8.parse("En" + SECRET);
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

  const urlSafeEncrypted = encrypted
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
  return urlSafeEncrypted;
};
// Decryption Function
export const decryptData = (encryptedData) => {
  const SECRET = "DevopsLabs2024";
  const key = CryptoJS.enc.Utf8.parse("En" + SECRET);
  let base64String = encryptedData
    .replace(/-/g, "+")
    .replace(/_/g, "/")
    .padEnd(
      encryptedData.length +
      (encryptedData.length % 4 === 0 ? 0 : 4 - (encryptedData.length % 4)),
      "="
    );
  const decrypted = CryptoJS.AES.decrypt(base64String, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const formatGroup = (value) => {
  if (!Array.isArray(value)) {return "-";}
  return value.map((role, index) => (
    <div key={role}>
      {role}
      {index < value.length - 1 && ","}
    </div>
  ));
};

export const userRoleExtract = (userRole) => {
  if (userRole && userRole.length !== 0) {
      return userRole[0];
  }
  return null;
};


export const DDAllHide = () => {
    const dispatch = useDispatch();
     dispatch(hideOffCanvas(false));
     dispatch(hideOffCanvasThree(false));
     dispatch(hideOffCanvasLast(false));
};